import { observable, action } from "mobx";
import { isDataExist } from "Utils/dataTools";
import * as services from "../services/retro";
import { message } from "antd";
import { omit, isEmpty } from "lodash";

class Inspect {
  @observable isLoading = false;
  @observable loading = false;
  @observable searchData = [];
  @observable tableList = {};
  @observable treeNodeDs = [];
  @observable orgChartDs = {};

  /* 已查询叶子下的详情节点 --- 根据对应的操作进入不同的详情 */
  @observable type = 0;
  @observable infos = [];
  @observable pageInfo = { pageIndex: 1, pageSize: 10 };
  @observable currentRecord = {};
  @observable detailVisible = false;
  @observable detailLoading = false;

  /* 查询列表的数据源 */
  @action async getSearchData(params) {
    try {
      let res = await services.getRequest(
        services.requestUrl.getSearchData,
        params
      );
      if (isDataExist(res)) {
        this.searchData = res.data.data;
      }
    } catch (error) {
      console.log(error);
    }
  }

  /* 设置递归 */
  setChildren = data => {
    let array = [];
    for (let item of data) {
      let current = {
        name: "工单编号：" + item.workNo,
        id: item.workId,
        key: item.workId,
        children: []
      };
      if (item.isChildren) {
        current.title =
          "<div class='org-title isChildren'><span>工序名称：" +
          item.procedureName +
          "(去处)</span></div>";
      } else {
        current.title =
          "<div class='org-title isChildren'><span>工序名称：" +
          item.procedureName +
          "(来源)</span></div>";
      }
      if (!isEmpty(item.childMenu)) {
        current.children = this.setChildren(item.childMenu);
      }

      array.push(current);
    }
    return array;
  };

  //获取追溯的数据表格
  @action async getData(type, params) {
    this.isLoading = true;
    this.tableList = [];
    //1追溯数据查询列表,2追溯报告管理查询
    const url =
      type === 1
        ? services.requestUrl.getTreeData
        : services.requestUrl.getReport;
    try {
      let res = await services.getRequest(url, params);
      this.isLoading = false;
      if (isDataExist(res)) {
        if (type === 2) {
          this.tableList = res.data.data;
        } else {
          let data = res.data.data;
          let orgChartDs = {
            name: "工单编号：" + data.workNo,
            title:
              "<div class='org-title'><span>工序名称：" +
              data.procedureName +
              "(根节点)</span></div>",
            id: data.workId,
            key: data.workId,
            children: []
          };
          if (!isEmpty(data.childMenu)) {
            orgChartDs.children = this.setChildren(data.childMenu);
          }
          this.orgChartDs = orgChartDs;
        }
      }
    } catch (error) {
      console.log(error);
    }
  }
  /* 获取追溯的叶子节点详情 */
  @action.bound async getTreeNodeDetail(params) {
    this.loading = true;
    try {
      let res = await services.getRequest(
        services.requestUrl.getTreeNodeDetail,
        params
      );
      this.loading = false;
      if (isDataExist(res)) {
        this.treeNodeDs = res.data.data;
      }
    } catch (error) {
      console.log(error);
    }
  }

  /* 根据工单获取对应信息 */
  @action async getInfoByWorkId(type, params) {
    this.detailLoading = true;
    try {
      // type: history 获取历史数据  device：获取设备状态  inspect：获取检测信息
      let req =
        type === "history"
          ? services.requestUrl.getHistoryByWork
          : type === "device"
          ? services.requestUrl.getDeviceByWrk
          : type === "inspect"
          ? services.requestUrl.getInspectByWork
          : services.requestUrl.getHistoryByWork;
      let res = await services.getRequest(req, params);
      this.detailLoading = false;
      if (isDataExist(res)) {
        this.infos = res.data.data.items;
        this.pageInfo = res.data.data.page;
      }
    } catch (error) {
      console.log(error);
    }
  }

  @action clearData() {
    this.type = 0;
    this.infos = [];
    this.pageInfo = { pageIndex: 1, pageSize: 10 };
    this.currentRecord = {};
    this.detailVisible = false;
  }
}

let InspectStore = new Inspect();
export default InspectStore;
